
import { Component,Input,OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { SubmitQuoteModel } from '../../../core/model/submit-quote-model';
import {CustomProductsService} from '../../../modules/custom-landing/custom-products/custom-products.service';
import { QuoteEditModel } from 'src/app/core/model/quote-edit-model';
import { QuoteStatusModel } from 'src/app/core/model/quote-status-model';
import { QuoteActionModel } from 'src/app/core/model/quote-action-model';
import { ToastrService } from 'ngx-toastr';
import { TranslationService, I18nModule } from '@spartacus/core';
import { NgIf } from '@angular/common';
@Component({
    selector: 'app-cancel-bid-modal',
    templateUrl: './cancel-bid-modal.component.html',
    styleUrls: ['./cancel-bid-modal.component.scss'],
    imports: [NgIf, I18nModule]
})
export class CancelBidModalComponent implements OnInit {
  // @ViewChild('cancelModal') private modalContent: TemplateRef<CancelBidModalComponent>;
  submitQuoteModel = new SubmitQuoteModel();
  quoteStatusModel = new QuoteStatusModel();
  quoteEditModel = new QuoteEditModel();
  quoteActionModel = new QuoteActionModel();
  
  disabledBtn = false;
  productInfo: any;
  error: string;
  @Input() from: string = '';
  @Input() data: string = '';
  constructor(private router: Router,
              private customProductService: CustomProductsService, private modalService: NgbModal, private toastService: ToastrService,
              private modalRef: NgbActiveModal
              , private translation: TranslationService){
  }
  ngOnInit(): void {
    this.translation.translate('home.toastErrorMessages.something').subscribe(res => {
      this.error = res;
    });
  }
  // open(data: any): any {
  //   this.productInfo = data;
  //   this.modalRef = this.modalService.open(this.modalContent, {centered: true});
  //   this.modalRef.result.then();
  // }

  close(): void {
    this.modalRef.close();
  }

  dismiss(): any {
    this.modalRef.dismiss();
  }

  editQuote(data): any {
    this.disabledBtn = true;
    this.quoteEditModel.quoteAction = this.quoteActionModel.cancel;
    this.quoteEditModel.quoteCode = data.quoteCode;
    this.quoteEditModel.quoteEntryRequest.basePrice = data.quoteEntries[0].price;
    this.quoteEditModel.quoteEntryRequest.productCode = data.quoteEntries[0].productCode;
    this.quoteEditModel.quoteEntryRequest.quantity = data.quoteEntries[0].quantity;
    this.quoteEditModel.quoteTemplate = {};

    this.customProductService.EditQuote(this.quoteEditModel).subscribe((res: any) => {
      if (res.status && res.status !== 'FAILED') {
        this.customProductService.scrollToTop();
        this.disabledBtn = false;
        this.close();
        this.checkQuoteStatusResult(res.status);
      } else {
        this.toastService.show(this.error);
        this.disabledBtn = false;
        this.close();
      }

    },
      err => {
        this.toastService.show(this.error);
        this.disabledBtn = false;
        this.close();
      });
  }

  checkQuoteStatusResult(quoteStatus): any {
    if (quoteStatus) {
      this.customProductService.quoteStatusName = quoteStatus;
      this.customProductService.isRedirectFromQuotesDetails = true;
      const currentUrl = this.router.url;
      if (currentUrl === '/quotes/myquotes') {
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this.router.navigate([currentUrl]);
      });
      }else{
        this.router.navigate([`/quotes/myquotes`]);
      }

    }
  }
}
